export default __webpack_public_path__ + "static/media/regulamento-de-compras-mario-bezerra.0119009b.pdf";